import { AEMNavigation, AEMOptions } from "./models/AEMPage.model"
import {
	AEMResponse,
	AEMComponentArray,
	AEMAppSetting,
	AEMAppSettingResponse
} from "./models/AEMResponse.model"
export interface AEMResponseMapper {
	parse(data: AEMResponse, options?: AEMOptions): AEMResponse
}

export const createDefaultMapper = (): AEMResponseMapper => ({
	parse: (data) => data
})

export const createItemsArrayMapper = (): AEMResponseMapper => ({
	parse: (data: AEMComponentArray<AEMResponse>) => {
		return data.items
	}
})

export const createNavigationMapper = (): AEMResponseMapper => ({
	parse: (data: AEMNavigation) => {
		if (!Array.isArray(data) || !data[0]?.children) {
			throw new Error(
				"Invalid data structure: createNavigationMapper missing children"
			)
		}
		return data
	}
})

export const createSettingsMapper = (): AEMResponseMapper => ({
	parse: (data: AEMAppSettingResponse) => {
		const settings = data?.items?.[0]?.json
		const keys = Object.keys(settings)
		const mappedData = {} as AEMAppSetting
		for (const key of keys) {
			if (typeof settings[key] === "boolean") {
				mappedData[key] = settings[key]
			} else if (typeof settings[key] === "string") {
				const val = settings[key] as string
				if (val === "TRUE" || val === "FALSE") {
					mappedData[key] = val === "TRUE"
				} else {
					mappedData[key] = val
				}
			} else {
				mappedData[key] = settings[key] as number
			}
		}
		return mappedData
	}
})
